import { useContext } from 'react';

import { TableContext, TableContextValue } from './TableContext.js';

export const useTableContext = (): TableContextValue => {
  const tableContext = useContext(TableContext);

  if (!tableContext) {
    return {
      variants: [],
      isLoading: false,
      placeholderRowsCount: 10,
      setVariants: () => {},
    } as TableContextValue;
  }

  return tableContext;
};
